module.exports = __webpack_public_path__ + "img/6-2.2e1efb35.png";